import { SalesOrderStatus } from '../constants/sales-order-status.js';
/**
 * Edges shared by every path. The Temporal workflow itself writes Awaiting Approval and Rejected
 * when `evaluateSalesOrderApproval` flags an order at Issue time (see `handle-awaiting-approval.ts`
 * / `sales-order-workflow-stage.ts`) — CRM (NUDOOL-233 / PR 3) only fires the `approveSalesOrder`
 * / `rejectSalesOrder` signals that resolve that branch; it never writes `statusId` directly.
 */
const COMMON_NEXT_STATUSES = {
    [SalesOrderStatus.DRAFT]: [
        SalesOrderStatus.AWAITING_APPROVAL,
        SalesOrderStatus.SUBMITTED,
        SalesOrderStatus.CANCELLED,
    ],
    [SalesOrderStatus.AWAITING_APPROVAL]: [
        SalesOrderStatus.SUBMITTED,
        SalesOrderStatus.REJECTED,
        SalesOrderStatus.CANCELLED,
    ],
    [SalesOrderStatus.SUBMITTED]: [SalesOrderStatus.ACCEPTED, SalesOrderStatus.CANCELLED],
    // Shipped is en route: it is delivered, or cancelled (a Standard order only through Failed Delivery).
    [SalesOrderStatus.SHIPPED]: [SalesOrderStatus.DELIVERED, SalesOrderStatus.CANCELLED],
    [SalesOrderStatus.DELIVERED]: [SalesOrderStatus.COMPLETE],
    // A reversed payment that leaves a Complete order unsettled reopens it at Delivered.
    [SalesOrderStatus.COMPLETE]: [SalesOrderStatus.DELIVERED],
    [SalesOrderStatus.CANCELLED]: [],
    [SalesOrderStatus.REJECTED]: [],
};
/**
 * Only the Standard path schedules its own delivery. Drop Ship (the vendor ships direct)
 * and Credit Return (a receipt, not a delivery) go straight from Accepted to Shipped —
 * see NUDOOL-109.
 */
const PATH_NEXT_STATUSES = {
    Standard: {
        // Accept writes Delivery Scheduling, where manual-path runs wrote Accepted.
        [SalesOrderStatus.SUBMITTED]: [
            SalesOrderStatus.ACCEPTED,
            SalesOrderStatus.DELIVERY_SCHEDULING,
            SalesOrderStatus.CANCELLED,
        ],
        [SalesOrderStatus.ACCEPTED]: [SalesOrderStatus.DELIVERY_SCHEDULING, SalesOrderStatus.CANCELLED],
        [SalesOrderStatus.DELIVERY_SCHEDULING]: [
            SalesOrderStatus.READY_TO_DELIVER,
            SalesOrderStatus.CANCELLED,
        ],
        [SalesOrderStatus.READY_TO_DELIVER]: [SalesOrderStatus.SHIPPED, SalesOrderStatus.CANCELLED],
    },
    DropShip: {
        [SalesOrderStatus.ACCEPTED]: [SalesOrderStatus.SHIPPED, SalesOrderStatus.CANCELLED],
    },
    CreditReturn: {
        [SalesOrderStatus.ACCEPTED]: [SalesOrderStatus.SHIPPED, SalesOrderStatus.CANCELLED],
    },
};
/** The statuses `from` may legally move to next, given the order's Temporal path. */
export function allowedNextSalesOrderStatuses(from, path) {
    return PATH_NEXT_STATUSES[path][from] ?? COMMON_NEXT_STATUSES[from] ?? [];
}
//# sourceMappingURL=allowed-next-sales-order-statuses.js.map